import { useNavigate } from "react-router-dom";

const NavButton = ({ name, navfunc, active }) => {

    //console.log("navbtn", name, active);

    return (
        // biome-ignore lint/a11y/useKeyWithClickEvents: <explanation>
        <div className={active ? `menuText ${name} active`: `menuText ${name}`} onClick={() => { navfunc(`/${name}`) } }>
            {name}
        </div>
    )
}

export default NavButton;